import React from 'react'
import "./newsletter.css"
import NlImg2 from "./images/2 new.png"

function Newsletter() {
  return (
    <div className='nl-container'>
        <img src={NlImg2} alt="" className="nl-img" />
      <div className="nl-content">
        <h1 className="nl-heading">SignUp for Newsletter</h1>
        <p className="nl-para">Be the first one to know about the latest products</p>
        <div className="nl-input-container">
          <input type="email" placeholder='Enter your Email' className="nl-input" />
          <button className="nl-btn" >Subscribe</button>
        </div>
      </div>
    </div>
  )
}

export default Newsletter
